import { useEffect, useContext } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import TagManager from 'react-gtm-module';
// Our Components
import { AuthContext } from 'context/auth-context';
import { Maitenance } from 'pages/Maitenance.page';
import { theme } from 'context/themeProvider';
import AppRoutes from 'routes/app.routes';

const { REACT_APP_GOOGLE_TAG_MANAGER_ID } = process.env;

const tagManagerArgs = {
    gtmId: REACT_APP_GOOGLE_TAG_MANAGER_ID
};

function App() {
    const { serverDown } = useContext(AuthContext);

    useEffect(() => {
        TagManager.initialize(tagManagerArgs);
    }, []);

    return <ThemeProvider theme={theme}>{serverDown ? <Maitenance /> : <AppRoutes />}</ThemeProvider>;
}

export default App;
